import { render, staticRenderFns } from "./GaleriaSection.vue?vue&type=template&id=0d0c5696&"
import script from "./GaleriaSection.vue?vue&type=script&lang=js&"
export * from "./GaleriaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports